import { FC, useEffect, useState } from "react";
import { OrderTypeModel } from "../models";
import { formatToDate, getTimeSlotsInTimestamp, transDate } from "../helpers";
import { Form } from "react-bootstrap";

type Props = {
  orderType: OrderTypeModel;
  handleDateChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleTimeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const AsapLater: FC<Props> = ({
  orderType,
  handleDateChange,
  handleTimeChange,
}) => {
  // const tabOptions = ['ASAP', 'Later'];
  // const [activeTab, setActiveTab] = useState('ASAP');
  const [days, setDays] = useState<any>([]);
  const [timeslots, setTimeSlots] = useState<Date[]>([]);

  const formatTime = (date: Date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = (((hours + 11) % 12) + 1)
      .toString()
      .padStart(2, "0"); // Converts 0 to 12 for 12AM
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    return `${formattedHours}:${formattedMinutes}${amPm}`;
  };

  const handleSlots = (date: Date) => {
    const selectedDayIndex = date.getDay() || 7;
    const timings: any = orderType.timing[selectedDayIndex] || [];
    const slots: Date[] = getTimeSlotsInTimestamp(
      date,
      timings,
      orderType.advance_time.toString(),
    );
    const filteredSlots = slots.filter(
      (slot) => slot.getTime() > new Date().getTime(),
    );
    setTimeSlots(filteredSlots);
  };

  const generateTimeSlots = (
    start: Date,
    end: Date,
    isToday: boolean,
    slots: any,
  ): any => {
    if (start > end) return slots;

    const now = new Date();
    if (!isToday || (isToday && start > now)) {
      const formattedTime = formatTime(start);
      slots.push(formattedTime);
    }

    const nextTime = new Date(start.getTime());
    nextTime.setMinutes(start.getMinutes() + 30);

    return generateTimeSlots(nextTime, end, isToday, slots);
  };

  useEffect(() => {
    const advanceDays = Number(orderType.advance_day);
    const newDays = [];

    for (var i = 0; i <= advanceDays; i++) {
      const date = new Date();
      date.setDate(date.getDate() + i);
      date.setHours(0, 0, 0, 0);

      // Only add if the store has timings for this day
      const dayIndex = date.getDay() || 7;
      if (orderType.timing[dayIndex]) {
        const formattedDate = formatToDate(date);
        newDays.push(formattedDate);
      }
    }

    setDays(newDays);
    handleSlots(new Date());
  }, []);

  // const handleTabChange = (tab: string) => {
  //   setActiveTab(tab);
  // };

  const handleOnDateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    const [day, month, year] = selectedValue.split("/").map(Number);
    const selectedDate = new Date(year, month - 1, day);
    handleSlots(selectedDate);
    handleDateChange(e);
  };

  return (
    <>
      {/* <div className="tick_mark">
        <ul>
          {tabOptions.map((tab) => (
            <li
              key={tab}
              className={activeTab === tab ? 'active' : ''}
              onClick={() => handleTabChange(tab)}
            >
              {tab}
            </li>
          ))}
        </ul>
      </div> */}

      <div className="select_piup">
        {orderType.advance_day > 0
          ? `Select a ${orderType.type} time upto ${orderType.advance_day} days in advance`
          : `Select a ${orderType.type} time`}
      </div>

      <div className="row mb-2">
        <div className="col-6">
          <Form.Select onChange={handleOnDateChange}>
            <option>Select a Day</option>
            {days.map((item: any, key: any) => (
              <option key={key} value={item}>
                {transDate(item)}
              </option>
            ))}
          </Form.Select>
        </div>
        <div className="col-6">
          <Form.Select onChange={handleTimeChange}>
            {timeslots.map((item: Date, key: any) => (
              <option key={key} value={formatTime(item)}>
                {formatTime(item)}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>
    </>
  );
};
